import React from 'react'
import { Box, Stack, Badge, FormControl, Input } from '@/components/lib'

export default function Integer ({ dataType, value, onChange }) {
  const localOnChange = e => {
    const re = /^[0-9\b-]+$/
    if (e.target.value === '') {
      onChange(null)
    } else if (e.target.value === '-') {
      onChange('-')
    } else if (re.test(e.target.value)) {
      onChange(parseInt(e.target.value))
    }
  }

  return (
    <Box>
      <FormControl
        helperText={(value !== null && value !== undefined)
          ? (
            <Stack spacing={2} direction='row'>
              {dataType?.minimumValue != null ? <Badge colorPalette={value < dataType.minimumValue ? 'red' : 'green'}>Min: {dataType.minimumValue}</Badge> : null}
              {dataType?.maximumValue != null ? <Badge colorPalette={value > dataType.maximumValue ? 'red' : 'green'}>Max: {dataType.maximumValue}</Badge> : null}
            </Stack>)
          : null}
      >
        <Input bg='bg.surface' value={value ?? ''} onChange={localOnChange} placeholder='Enter a number...' />
      </FormControl>
    </Box>
  )
}
